import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.output.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver errors - this is a known React/Chrome issue that's harmless
const originalError = console.error;
console.error = (...args: any[]) => {
  if (
    args[0]?.toString().includes('ResizeObserver loop') ||
    args[0]?.toString().includes('ResizeObserver loop completed')
  ) {
    return; // Suppress ResizeObserver errors
  }
  originalError.apply(console, args);
};

// Also handle at the window error level
const handleError = (event: ErrorEvent) => {
  if (
    event.message?.includes('ResizeObserver loop') ||
    event.message?.includes('ResizeObserver loop completed')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
};
window.addEventListener('error', handleError);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
